import script from "./TitleHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TitleHeader.vue?vue&type=style&index=0&id=e6b57eea&lang=scss&scoped=true"
import "./TitleHeader.vue?vue&type=style&index=1&id=e6b57eea&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b57eea"]])

export default __exports__